import { gql } from '@apollo/client';

export default gql`
  query bookingsPerTrain(
    $departureDate: String!
    $trainNumber: String!
    $reference: String
    $coach: String
    $seat: String
    $includeCancelled: Boolean
  ) {
    bookingsPerTrain(
      departureDate: $departureDate
      trainNumber: $trainNumber
      reference: $reference
      coach: $coach
      seat: $seat
      includeCancelled: $includeCancelled
    ) {
      reference
      status
      expiryTimestamp
      customer {
        firstName
        lastName
      }
      products {
        code
        type
        name
      }
      passengers {
        coach
        number
        passenger {
          firstName
          lastName
        }
      }
      passengerCount
      outboundRoute {
        dateTime
        origin
        destination
      }
      inboundRoute {
        dateTime
        origin
        destination
      }
      externalBookingReferences {
        source
        type
        externalId
      }
    }
  }
`;
